const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Корпоративный офис",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Ветеринарная клиника",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Обязательно",
    },
  },
  salutation: {
    label: "Обращение",
    placeholder: "Выберите обращение",
    errors: {
      required: "Обращение обязательно",
      invalid: "Выберите действительное обращение",
    },
  },
  firstName: {
    label: "Имя",
    placeholder: "Иван",
    errors: {
      authenticatedNameUpdateTrial:
        "Ви увійшли в систему, і ваше ім’я не можна змінити.",
      required: "Имя обязательно",
      minLength: "Имя должно быть минимум 2 символа",
      maxLength: "Имя должно быть максимум 50 символов",
    },
  },
  lastName: {
    label: "Фамилия",
    placeholder: "Иванов",
    errors: {
      authenticatedNameUpdateTrial:
        "Ви увійшли в систему, і ваше ім’я не можна змінити.",
      required: "Фамилия обязательно",
      minLength: "Фамилия должна быть минимум 2 символа",
      maxLength: "Фамилия должна быть максимум 50 символов",
    },
  },
  email: {
    label: "Эл. почта",
    placeholder: "ivan.ivanov@example.com",
    description:
      "Введите свой личный адрес электронной почты, а не общий адрес электронной почты.",
    prefixWarningTitle: "Обнаружен общий почтовый ящик",
    prefixWarningDescription:
      "Мы рекомендуем использовать личный адрес электронной почты для лучшего и более персонализированного опыта",
    errors: {
      authenticatedEmailUpdateTrial:
        "Вы вошли в систему, и ваш адрес электронной почты нельзя изменить.",
      required: "Эл. почта обязательно",
      invalidEmail: "Введите действительный адрес электронной почты",
      emailAssociatedWithYourAccount:
        "Ваш адрес электронной почты связан с вашей учетной записью и не может быть изменен.",
    },
  },
  confirmEmail: {
    label: "Подтвердить электронную почту",
    placeholder: "ivan.ivanov@example.com",
    errors: {
      authenticatedEmailUpdateTrial:
        "Вы вошли в систему, и ваш адрес электронной почты нельзя изменить.",
      required: "Подтверждение электронной почты обязательно",
      invalidEmail: "Введите действительный адрес электронной почты",
      emailMatchError: "Адреса электронной почты не совпадают",
    },
  },
  password: {
    label: "Пароль",
    placeholder: "Введите свой пароль",
    errors: {
      required: "Пароль обязательно",
    },
  },
  confirmPassword: {
    label: "Подтвердить пароль",
    placeholder: "Подтвердить парольsi",
    errors: {
      required: "Подтверждение пароля обязательно",
      passwordMatchError: "Пароли не совпадают",
    },
  },
  addressLine1: {
    label: "Адрес строка 1",
    placeholder: "улица Примерная 123",
    errors: {
      required: "Адрес строка 1 обязательно",
      minLength: "Адрес строка 1 должен быть не менее 5 символов",
      maxLength: "Адрес строка 1 должен быть максимум 100 символов",
    },
  },
  addressLine2: {
    label: "Адрес строка 2",
    placeholder: "Квартира 4B",
    errors: {
      required: "Адрес строка 2 обязательно",
      maxLength: "Адрес строка 2 должен быть максимум 100 символов",
    },
  },
  city: {
    label: "Город",
    placeholder: "Москва",
    errors: {
      required: "Город обязательно",
      minLength: "Город on oltava минимум 2 символа",
      maxLength: "Город on oltava максимум 50 символов",
    },
  },
  country: {
    label: "Страна",
    placeholder: "Выберите страну",
    errors: {
      required: "Страна обязательна для заполнения",
      invalid: "Пожалуйста, выберите действительную страну",
    },
  },
  state: {
    label: "Штат",
    placeholder: "Выберите штат",
    errors: {
      required: "Штат обязательно",
      invalid: "Выберите действительный штат",
    },
  },
  jurisdiction: {
    label: "Юрисдикция",
    placeholder: "Выберите юрисдикцию",
    errors: {
      required: "Юрисдикция обязательно",
      invalid: "Выберите действительную юрисдикцию",
    },
  },
  zipCode: {
    label: "Почтовый индекс",
    placeholder: "101000",
    errors: {
      required: "Почтовый индекс обязательно",
      invalid: "Введите действительный почтовый индекс",
    },
  },
  role: {
    label: "Роль",
    placeholder: "Выберите свою роль",
    errors: {
      required: "Выберите свою роль",
      invalid: "Выберите действительную роль",
    },
  },
  businessType: {
    label: "Тип бизнеса",
    placeholder: "Выберите тип бизнеса",
    errors: {
      required: "Тип бизнеса обязательно",
      invalid: "Выберите действительный тип бизнеса",
    },
  },
  businessName: {
    label: "Название компании",
    placeholder: "Введите название компании",
    errors: {
      required: "Название компании обязательно",
      minLength: "Название компании должно быть минимум 2 символа",
      maxLength: "Название компании должно быть максимум 100 символов",
    },
  },
  businessSearch: {
    label: "Поиск компании:",
    addNewAccount: "Добавить новую учетную запись компании",
    canNotFindBusiness: "Не можете найти свою компанию?",
    guideline: "Введите свой почтовый индекс, затем выберите из списка ниже.",
    guidelineForNameSearch:
      "Введите полное название компании, затем выберите из списка.",
    placeholder: "Где вы работаете?",
    noResults: "Результаты не найдены",
    searching: "Поиск...",
    selectedBusinessHeading: "Выбранная компания:",
    selectedBusinessNotCorrect: "Неправильно?",
    selectedBusinessTryAgain: "Попробовать снова",
    selectedBusinessDismiss: "Отклонить компанию",
    resultsFound: {
      singular: "Найдена 1 компания",
      plural: "Найдено несколько компаний",
    },
    errors: {
      network:
        "Проблемы с подключением к службе поиска компаний. Пожалуйста, попробуйте позже.",
    },
  },
  explicitConsent: {
    label:
      "Установив этот флажок, я соглашаюсь получать маркетинговые сообщения от Elanco.",
    errors: {
      required: "Требуется согласие",
    },
  },
  explicitSmsConsent: {
    label:
      "Установив этот флажок, я соглашаюсь получать маркетинговые сообщения от Elanco по SMS/текстовым сообщениям.",
    errors: {
      required: "Требуется согласие на получение SMS",
    },
  },
  telephone: {
    label: "Личный телефон",
    placeholder: "Введите свой личный номер телефона",
    dialCodeLabel: "Код",
    dialCodePlaceholder: "Поиск страны...",
    errors: {
      invalid: "Введите действительный номер телефона.",
    },
  },
  businessTelephone: {
    label: "Телефон компании",
    placeholder: "Введитеномер телефона компании",
    dialCodeLabel: "Код",
    dialCodePlaceholder: "Поиск страны...",
    errors: {
      invalid: "Введите действительный номер телефона.",
    },
  },
  professionalNumber: {
    label: "Профессиональный номер",
    placeholder: "1234567",
    errors: {
      required: "Введите профессиональный номер",
      maxLength: "Ввод превышает ограничение по символам",
    },
  },
  addressSearch: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  businessSearchField: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  checkbox: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  combobox: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  datePicker: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  dateRange: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  dateTime: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  emailField: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  fileInput: {
    errors: {
      required: "Выберите файл",
    },
  },
  number: {
    errors: {
      required: "Введите число",
      minValue: "Введите значение больше минимального",
      maxValue: "Введите значение меньше максимального",
    },
  },
  passwordField: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  rangeSlider: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  select: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  telephoneField: {
    errors: {
      required: "Введите только цифры",
      invalidTelephone: "Введите действительный номер телефона",
      invalidFormat: "Неправильный формат номера",
    },
  },
  text: {
    errors: {
      required: "Используйте только буквы (А-Я), цифры (0-9) и без символов",
      maxLength: "Ввод превышает ограничение по символам",
      minLength: "Ввод должен быть минимум 2 символа",
    },
  },
  textarea: {
    characters: "символов",
  },
  time: {
    errors: {
      required: "Это поле обязательно",
    },
  },
  form: {
    errors: {
      generic: "Lomakkeen lähettämisessä tapahtui virhe. Попробовать снова.",
      reportAnIssue: "Сообщить о проблеме.",
      configuration: "Ошибка конфигурации",
      noFormQuestionsAvailable: "Элементы формы недоступны.",
      formComponentLoad:
        "Не удалось загрузить компонент формы из-за неподдерживаемого поля.",
      code: "Код",
      type: "Tyyppi",
      missingRequiredFields:
        "В форме отсутствуют обязательные поля (Эл. почта и/или Согласие). Обратитесь к администратору для исправления конфигурации формы.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Защита животных - Ветеринар",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Производитель - смешанный/другое",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Розничный продавец",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Овцевод",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Ветеринар",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Ветеринар", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Ветеринар, владелец клиники",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Ветеринарavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Ветеринарная клиника - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Ветеринарная клиника - Ветеринар",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Ветеринарная клиника - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Специалист-ветеринар",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Ветеринар",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Господин",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Господин",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Госпожа",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Госпожа",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Профессор",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
